import type { MusicalToken } from '../../types/music';



/** Duración VexFlow por token rítmico canónico. */

export const TOKEN_VEX_DURATION: Record<MusicalToken, string> = {

  W: 'w',

  H: 'h',

  Q: 'q',

  E: '8',

  S: '16',

  R_W: 'wr',

  R_H: 'hr',

  R_Q: 'qr',

  R_E: '8r',

  R_S: '16r',

};



export function tokenToVexDuration(token: MusicalToken): string {

  return TOKEN_VEX_DURATION[token] ?? 'q';

}



export function isRestToken(token: MusicalToken): boolean {

  return token.startsWith('R_');

}



/** Convierte pitch tipo G4, C5, F#4 o g/4, f#/5 a clave VexFlow. */

export function pitchToVexKey(pitch: string): string {

  const raw = String(pitch || 'g4').trim();

  const vexForm = raw.match(/^([a-g])([#b]?)\/(\d)$/i);

  if (vexForm) {

    return `${vexForm[1]!.toLowerCase()}${vexForm[2] ?? ''}/${vexForm[3]}`;

  }

  const m = raw.match(/^([A-Ga-g])([#b]?)(\d)?$/);

  if (!m) return 'g/4';

  const letter = m[1]!.toLowerCase();

  const acc = m[2] === '#' ? '#' : m[2] === 'b' ? 'b' : '';

  const octave = m[3] ?? '4';

  return `${letter}${acc}/${octave}`;

}



/** Figura Boom / Chile para fallback Eco. */

export function tokenToNoteFigure(token: MusicalToken): 'redonda' | 'blanca' | 'negra' | 'corchea' | 'semicorchea' {

  switch (token) {

    case 'W':

      return 'redonda';

    case 'H':

      return 'blanca';

    case 'E':

    case 'R_E':

      return 'corchea';

    case 'S':

    case 'R_S':

      return 'semicorchea';

    default:

      return 'negra';

  }

}

